export type IProductItem = {
    variantId: string;
    tips: string;
    save: string;
    desc: string;
    descList: string[];
    subDescList: string[];
    link: string;
    detailLink?: string;
    // 接口注入
    productTitle?: string;
    img?: string;
    price?: number;
    compareAtPrice?: number;
};

export const products: Record<string, IProductItem[]> = {
    us: [
        {
            variantId: '54376072413257',
            tips: 'First Choice',
            save: 'Save $642 on Bills Annually',
            desc: 'Assuming 2000W full solar input',
            descList: ['36.7%', '4,015kWh', '4,002 kg'],
            subDescList: ['self-consumption rate', 'generated per year with this system', 'reduces CO₂ emissions'],
            link: '',
        },
        {
            variantId: '54383476146249',
            tips: '2kW STREAM Ultra Basic Set',
            save: 'Save $513 on Bills Annually',
            desc: 'Assuming 1600W solar input',
            descList: ['29%', '3,212kWh', '3,202 kg'],
            subDescList: ['self-consumption rate', 'generated per year with this system', 'reduces CO₂ emissions'],
            link: '',
        },
        {
            variantId: '54383476179017',
            tips: '3.2kW STREAM Advanced Set',
            save: 'Save $1,027 on Bills Annually',
            desc: 'Assuming 3200W full solar input',
            descList: ['50%', '6,424kWh', '6,404 kg'],
            subDescList: ['self-consumption rate', 'generated per year with this system', 'reduces CO₂ emissions'],
            link: '',
        },
    ],
};
